import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconGooglemaps(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1C6.309 1 4.937 2.432 4.937 4.2c0 1.428 2.002 4.031 2.769 4.976a.373.373 0 0 0 .588 0c.767-.945 2.769-3.548 2.769-4.977C11.063 2.432 9.69 1 8 1zm0 4.266c-.564 0-1.02-.478-1.02-1.067S7.435 3.133 8 3.133c.564 0 1.02.477 1.02 1.066 0 .59-.456 1.067-1.02 1.067zM1.489 6.483A.813.813 0 0 0 1 7.237v6.356c0 .288.278.484.533.378l3.356-1.596V6.457c-.215-.406-.39-.8-.517-1.179L1.49 6.483zM8 10.133c-.342 0-.665-.158-.887-.431-.478-.59-.986-1.26-1.446-1.948v4.62L10.333 14V7.754a26.69 26.69 0 0 1-1.446 1.948c-.222.273-.545.43-.887.43zm6.467-5.041L11.11 6.688V14l3.4-1.42a.813.813 0 0 0 .489-.755V5.469c0-.287-.278-.484-.533-.377z"
      />
    </Icon>
  )
}
